import React from "react";
import { Box, Skeleton, Stack } from "@mui/material";
import { StyledCard } from "../styles";

const ActivityLogsSkeleton = () => {
  return (
    <StyledCard elevation={0} sx={{ p: 2 }}>
      <Stack spacing={2}>
        <Skeleton variant="rounded" height={52} />
        <Skeleton variant="rounded" height={52} />
        <Skeleton variant="rounded" height={52} />
        <Skeleton variant="rounded" height={52} />
        <Skeleton variant="rounded" height={52} />
        <Box display="flex" justifyContent="space-between" mt={1}>
          <Skeleton variant="text" width={140} height={36} />
          <Skeleton variant="rounded" width={220} height={36} />
        </Box>
      </Stack>
    </StyledCard>
  );
};

export default ActivityLogsSkeleton;
